export default __webpack_public_path__ + "locales/pt-BR/EmptyView.json?hash=4be20383225509b86bf2b1e0218c516d";